module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {

	fox.registerWidget('LSChatList', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				widgets: {
					chatList: {
						widget: 'AdvancedList',
						autoRender: true
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			var scrollContainer = this.requireOption('scrollContainer');

			this.registerOptions('#chatList', {
				'hooks.onStopAddedToDom': function () {
					$(this.element[0]).parents(scrollContainer).mCustomScrollbar({
						theme: this.getOption('scrollTheme') || 'minimal-dark'
					});

					this.getParent().scrollToBottom();
				}
			});

			this.callParent('init', arguments);
		},

		running: function () {
			this.cl = this.rwom1('#chatList');

			this.callParent('running', arguments);
		},

		scrollToBottom: function () {
			var scrollContainer = this.requireOption('scrollContainer');

			try {
				$(this.dom1(scrollContainer)).mCustomScrollbar('scrollTo', 'bottom', {scrollInertia: 200});
			} catch (e) {}
		},

		addMessage: function (m) {
			if (!this.cl) return;

			var active = this.isActive();

			if (this.cl._rendered === true) {
				return this.cl.wait('@this', 'addedToDom', {
					prefix: (Math.random() * Math.pow(10, 10)).toFixed()
				}).then(this.addMessage.bind(this, m));
			}

			return this.cl.appendItem(m, !active);
		},

		sendMessage: function (data) {
			console.log('LSChat -> sendMessage called');
		},

		reset: function () {
			this.cl.resetCollection();
		},

		updateScrollbar: function () {
			if (this.isEmbedded()) {
				this.getListScrollWrapperElement().mCustomScrollbar('update');
			}
		},

		getListScrollWrapperElement: function () {
			if (this.isEmbedded()) {
				return $(this.element[0]).parents(this.requireOption('scrollContainer'));
			}

			return false;
		},

		prepareList: function (list, mId) {
			return list.map(function (v) {
				if (v.uid === mId) {
					v.isBroadcaster = true;
				}

				if (!fox.isEmpty(v.dataset)) {
					try {
						v = fox.merge(v, JSON.parse(v.dataset));
					} catch (e) {}
				}

				return v;
			});
		}
	});

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/widget/Chat.js
// module id = 100
// module chunks = 4